var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "team-members-ctn"
  }, [_c('h2', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('profile.menu.team_members')))]), _c('div', {
    staticClass: "d-flex flex-wrap flex-sm-nowrap justify-space-between align-center mt-5"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-start align-sm-center mb-3 mb-sm-0"
  }, [_c('v-btn', {
    staticClass: "primary mb-2 mb-sm-0 mr-sm-4",
    attrs: {
      "disabled": _vm.hasExceededSeats
    },
    on: {
      "click": _vm.handleInviteUserDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.team_members_invite_a_new_user')) + " ")]), _vm.hasExceededSeats ? _c('div', [_c('span', {
    staticClass: "primary--text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('profile.team_members_upgrade_more_seats'))
    }
  })]) : _vm._e()], 1), _c('div', [_c('span', {
    staticClass: "text-active"
  }, [_vm._v(" " + _vm._s(_vm.formatNumber(_vm.usedMembersCount)) + " " + _vm._s(_vm.$t('used')) + " ")]), _vm._v(" / "), _c('span', {
    staticClass: "text-total"
  }, [_vm._v(" " + _vm._s(_vm.formatNumber(_vm.totalMembersCount)) + " " + _vm._s(_vm.$t('total')) + " ")])])]), _c('div', {
    staticClass: "team-members-table mt-5"
  }, [_c('v-row', {
    staticClass: "team-members-table-header font-light pa-0 ma-0 d-none d-sm-flex"
  }, [_c('v-col', {
    staticClass: "d-flex flex-start",
    attrs: {
      "cols": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.team_members_name')))]), _c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.team_members_email')))]), _c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.team_members_role')))]), _c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.team_members_status')))]), _c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.team_members_actions')))])], 1), _vm._l(_vm.teamMembers, function (member) {
    return _c('v-row', {
      key: member.id,
      staticClass: "pa-0 ma-0 team-members-table-item d-none d-sm-flex",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('div', {
      staticClass: "breakable-text"
    }, [_c('span', {
      staticClass: "font-medium mr-2 text-center"
    }, [_vm._v(_vm._s(_vm.fullName(member.first_name, member.last_name)))])])]), _c('v-col', {
      staticClass: "text-center",
      attrs: {
        "cols": "3"
      }
    }, [_c('div', {
      staticClass: "breakable-text"
    }, [_vm._v(_vm._s(member.email))])]), _c('v-col', {
      staticClass: "d-flex justify-center",
      attrs: {
        "cols": "2"
      }
    }, [_vm._v(_vm._s(_vm.transformRole(member.role)))]), _c('v-col', {
      staticClass: "d-flex justify-center",
      attrs: {
        "cols": "2"
      }
    }, [_vm._v(_vm._s(_vm.transformStatus(member.is_active)))]), _c('v-col', {
      staticClass: "text-center",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": "",
              "color": "primary"
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)];
        }
      }], null, true)
    }, [_c('v-list', [_c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.resetPassword(member);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('profile.team_members_action_reset_password')))])], 1), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.editUser(member);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('profile.team_members_action_edit_user')))])], 1), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeUser(member);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('profile.team_members_action_remove_user')))])], 1)], 1)], 1)], 1)], 1);
  }), _c('div', {
    staticClass: "d-block d-sm-none"
  }, _vm._l(_vm.teamMembers, function (member) {
    return _c('v-card', {
      key: 'mobile-' + member.id,
      staticClass: "mb-3 pa-3",
      attrs: {
        "outlined": ""
      }
    }, [_c('div', {
      staticClass: "d-flex justify-space-between mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('profile.team_members_name')))]), _c('strong', [_vm._v(_vm._s(_vm.fullName(member.first_name, member.last_name)))])]), _c('div', {
      staticClass: "d-flex justify-space-between mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('profile.team_members_email')))]), _c('span', [_vm._v(_vm._s(member.email))])]), _c('div', {
      staticClass: "d-flex justify-space-between mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('profile.team_members_role')))]), _c('span', [_vm._v(_vm._s(_vm.transformRole(member.role)))])]), _c('div', {
      staticClass: "d-flex justify-space-between mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('profile.team_members_status')))]), _c('span', [_vm._v(_vm._s(_vm.transformStatus(member.is_active)))])]), _c('div', {
      staticClass: "d-flex justify-space-between align-center"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('profile.team_members_actions')))]), _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": "",
              "color": "primary"
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)];
        }
      }], null, true)
    }, [_c('v-list', [_c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.resetPassword(member);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('profile.team_members_action_reset_password')))])], 1), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.editUser(member);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('profile.team_members_action_edit_user')))])], 1), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeUser(member);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('profile.team_members_action_remove_user')))])], 1)], 1)], 1)], 1)]);
  }), 1)], 2), _c('invite-user-dialog', {
    attrs: {
      "display-invite-user-dialog": _vm.displayInviteUserDialog,
      "is-editing": _vm.isEditing,
      "selected-user": _vm.selectedMember
    },
    on: {
      "update:displayInviteUserDialog": _vm.handleCloseDialog,
      "update:isEditing": function ($event) {
        _vm.isEditing = $event;
      },
      "update:is-editing": function ($event) {
        _vm.isEditing = $event;
      },
      "update:selectedUser": function ($event) {
        _vm.selectedMember = $event;
      },
      "update:selected-user": function ($event) {
        _vm.selectedMember = $event;
      }
    }
  }), _c('confirmation-dialog', {
    attrs: {
      "display-confirmation-dialog": _vm.displayConfirmationDialog,
      "title": _vm.confirmationDialogTitle,
      "confirmation-message": _vm.confirmationDialogMessage,
      "content": _vm.confirmationDialogContent
    },
    on: {
      "update:displayConfirmationDialog": _vm.closeConfirmationDialog,
      "handle-confirmation": _vm.handleRemoveMemberConfirmation
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }